import { IFrequency } from './IFrequency';

export interface IApprovalStrategy {
    guid: string;
    name: string;
    approbationStrategyLevelCollection: IApprovalStrategyLevel[];
    undoApproval?: boolean;
    allowInFuture?: boolean;
}

export interface IApprovalStrategyLevel {
    level: number;
    userCollection: string[];
    roleCollection: string[];
    justificationLevel: JustificationLevel;
    autoApprovalMethod: AutoApprovalMethod;
    autoApprovalDelay: IFrequency;
}

export enum JustificationLevel {
    Never,
    Always,
    OnApproval,
    OnRejection
}

export enum AutoApprovalMethod {
    None,
    ByDelay,
    ByPreviousApproval // is disabled for now
}